// extracted by mini-css-extract-plugin
module.exports = {"required":"styles_required__CAwvr","label":"styles_label__VWBKR"};